module.exports = __webpack_public_path__ + "img/code_zheng.7218d326.png";